// CoAuthorPanel — Invite a co-author by username (PRO only, 50/50 split).
import React from "react";
import { Crown } from "lucide-react";
import { tFases } from "../../../i18n/shadow-fases";

export const CoAuthorPanel = ({
  isPro, lang,
  coAuthorOn, setCoAuthorOn,
  coAuthorUsername, setCoAuthorUsername,
  coAuthorInviteStatus,
  onProGate,
}) => (
  <div className="mt-3 rounded-2xl border border-cyan-400/20 bg-cyan-400/[0.03] p-3">
    <label className="flex cursor-pointer items-center justify-between gap-2">
      <div className="flex items-center gap-2">
        <span className="text-[10px] font-black uppercase tracking-[0.22em] text-cyan-200">
          🤝 {tFases(lang, "publish_coauth_label")}
        </span>
        {!isPro && (
          <span className="inline-flex items-center gap-1 rounded-full border border-amber-400/40 bg-amber-400/10 px-2 py-0.5 text-[9px] font-bold uppercase tracking-[0.15em] text-amber-200">
            <Crown className="h-2.5 w-2.5" /> {tFases(lang, "publish_poll_pro")}
          </span>
        )}
        <span className="text-[10px] text-white/40">{tFases(lang, "publish_coauth_sub")}</span>
      </div>
      <input
        type="checkbox"
        checked={coAuthorOn}
        disabled={!isPro}
        onChange={(e) => {
          if (!isPro) { onProGate("chars"); return; }
          setCoAuthorOn(e.target.checked);
        }}
        data-testid="shadow-publish-coauthor-toggle"
        className="h-4 w-4 cursor-pointer accent-cyan-500 disabled:cursor-not-allowed"
      />
    </label>
    {coAuthorOn && isPro && (
      <div className="mt-3">
        <input
          value={coAuthorUsername}
          onChange={(e) => setCoAuthorUsername(e.target.value.slice(0, 20))}
          placeholder={tFases(lang, "publish_coauth_ph")}
          maxLength={20}
          data-testid="shadow-publish-coauthor-username"
          className="w-full rounded-xl border border-white/10 bg-white/[0.04] px-3 py-2 text-sm outline-none focus:border-cyan-400/50"
        />
        {coAuthorInviteStatus === "sent" && (
          <p className="mt-1.5 text-[10px] text-emerald-300" data-testid="coauthor-invite-sent">
            {tFases(lang, "publish_coauth_sent")}
          </p>
        )}
        {coAuthorInviteStatus === "error" && (
          <p className="mt-1.5 text-[10px] text-rose-300" data-testid="coauthor-invite-error">
            {tFases(lang, "publish_coauth_err")}
          </p>
        )}
      </div>
    )}
  </div>
);

export default CoAuthorPanel;
